/**
 * Loading / error / empty state wrapper.
 *
 * Replaces the repeated ternary pattern:
 *   {loading ? <LoadingSpinner /> : error ? <ConnectionWarning /> : empty ? <EmptyState /> : children}
 */

import type { ReactNode } from "react";
import { LoadingSpinner } from "./LoadingSpinner";
import { ConnectionWarning } from "./ConnectionWarning";
import { EmptyState } from "./EmptyState";

interface DataStateProps {
  loading: boolean;
  error?: boolean | string | null;
  errorMessage?: string;
  empty?: boolean;
  emptyMessage?: string;
  emptyAction?: ReactNode;
  children: ReactNode;
}

export function DataState({
  loading,
  error,
  errorMessage,
  empty,
  emptyMessage = "No data found.",
  emptyAction,
  children,
}: DataStateProps) {
  if (loading) return <LoadingSpinner />;
  if (error) return <ConnectionWarning message={errorMessage} />;
  if (empty) return <EmptyState message={emptyMessage} action={emptyAction} />;
  return <>{children}</>;
}
